import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cs{background:var(--shades-white);}.ssr-plugin'
import '.bo{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b8{max-width:77.5rem;}.ssr-plugin'
import '.ct{justify-content:stretch;}.ssr-plugin'
import '.cu{position:sticky;}.ssr-plugin'
import '.cv{top:0px;}.ssr-plugin'
import '.cw{z-index:10;}.ssr-plugin'
import '.cx{padding-block:1rem;}.ssr-plugin'
import '.cy{height:3rem;}.ssr-plugin'
import '.u{justify-content:space-between;}.ssr-plugin'
import '.cz{flex-wrap:wrap;}.ssr-plugin'
import '.d0{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bg{margin-top:2rem;}.ssr-plugin'
import '.d1{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab g b cs"
      >
        <div className="bo a c g b"
        >
          <div className="b8 a b ct cu cv cw cs"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cx cy a u c cz"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="d0 a b ab bg d1 b8"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
